module.exports = __webpack_public_path__ + "static/media/cover-ads-2.799f8b91.png";